import React from 'react'
import Banner from './Banner'

function Main() {
    return (
        <div>
            <Banner/>
        </div>
    )
}

export default Main
